import { Component, computed, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import { sanitizeDirectusObject } from "../../../../common/utils/sanitize-directus-object";
import { ItemsButtonBlock } from "../../../api/packbo/models/items-button-block";

@Component({
    selector: "packbo-button-block",
    templateUrl: "./button-block.template.html",
    imports: [DirectusTranslationPipe, PathFromItemPipe]
})
export class ButtonBlockComponent {
    public readonly buttonBlock = input.required<ItemsButtonBlock>();
    public readonly link = computed(() => sanitizeDirectusObject(this.buttonBlock().link));
}
